import React from 'react';
import Moment from 'moment';
import 'moment/locale/es';
import './paquete-detalle-transporte.css';

const Tramo = (props) => {
  const fecha = Moment(props.fecha).format('DD/MM/YY');
  return (
    <span>
      <div className='titulo-principal-viajes text-center'>
        {' '}
        {props.titulo}
        {' '}
      </div>
      <div className='row'>
        <div className='col-lg-12'>
          <div className='contenedor-info-viaje'>
            <span className='info text-center'>
              <div className='dia'>{fecha}</div>
              <div className='hora-destino '>
                <b>
                  <span className='iata color-dinamico'>
                    {' '}
                    {props.origen}
                    {' '}
                  </span>
                </b>
              </div>
            </span>
            <span className='escalas'>
              <hr />
            </span>
            <span className='info text-center'>
              <div className='dia'>{fecha}</div>
              <div className='hora-destino'>
                <b>
                  <span className='iata color-dinamico'>
                    {' '}
                    {props.destino}
                    {' '}
                  </span>
                </b>
              </div>
            </span>
          </div>
        </div>
      </div>
    </span>
  );
};

export default Tramo;
